import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ConcreteLayerService} from '../../services/concreteLayer/concrete-layer.service';
import {ConcreteHierarchyItemInterface} from '../../classes/concreteLayers/ConcreteHierarchyItemInterface';
import {Observable} from 'rxjs';
import {ConcreteLayer} from '../../classes/concreteLayers/ConcreteLayer';
import {UiAdapterService} from '../../services/uiAdapterService/ui-adapter.service';
import {Item} from '../../models/Item';
import {map} from 'rxjs/operators';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {AbstractObserver} from '../../classes/AbstractObserver/AbstractObserver';
import {OverlayService} from '../../services/overlay/overlay.service';

declare const Yiit;

@Component({
  selector: 'app-placed-items21',
  templateUrl: './placed-items21.component.html',
  styleUrls: ['./placed-items21.component.scss'],
  animations: [
    trigger('openedAnim', [
      // ...
      state('opened', style({
        height: '*',
        visibility: 'visible',
        overflow: 'hidden'
      })),
      state('closed', style({
        height: '0px',
        visibility: 'hidden',
        overflow: 'hidden'
      })),
      transition('opened <=> closed', [
        animate('0.5s ease')
      ]),
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlacedItems21Component extends AbstractObserver implements OnInit, AfterViewInit {

  public topCl: ConcreteHierarchyItemInterface;
  public Yiit = Yiit;
  public openedGroups = [];
  public overlayList = [];
  public isCads$: Observable<boolean>;

  get selectedLayer(): ConcreteLayer {
    const item = this.uiAdapterService.currentSelectedItem;
    if (item instanceof Item) {
      return this.concreteService.getParent(item) as ConcreteLayer;
    } else if (item instanceof ConcreteLayer) {
      return item;
    }
    return this.topCl as ConcreteLayer;
  }

  constructor(
    private uiAdapterService: UiAdapterService,
    private concreteService: ConcreteLayerService,
    private cd: ChangeDetectorRef,
    private overlayService: OverlayService,
  ) {
    super();
  }

  ngOnInit() {
    this.topCl = this.concreteService.getTopLevelCL();
    this.uiAdapterService.selectedItem$ = this.topCl;
    this.subscribeToObservable(this.uiAdapterService.selectedItem$, (() => {
      this.cd.detectChanges();
    }));
    this.isCads$ = this.overlayService
        .getFloorLayouts()
        .pipe(map((overlays: any[]) => {
          return overlays.length > 0;
        }));
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  public addConcreteLayer(parentConcreteId?) {

    let initialConcrete = null;
    if (parentConcreteId || parentConcreteId === null) {
      initialConcrete = new ConcreteLayer(null);
      initialConcrete.parentConcreteId = parentConcreteId;
    }

    this.concreteService.drawConcreteLayer(initialConcrete, (concrete: ConcreteLayer, error?) => {
      if (!error) {
        concrete.onSelect();
        this.uiAdapterService.selectedItem$ = concrete;
        this.cd.markForCheck();
      } else {
        alert(error);
      }
    });
  }

  getOverlays(): Observable<ConcreteLayer[]> {
    return this.concreteService.listChanged.pipe(map((items) => {
      items.forEach((item: ConcreteLayer) => {
        if (item.isOverlay && this.overlayList.indexOf(item) < 0) {
          if (item.getTitle() == null) {
            item.setTitle('Layout #' + item.id.toString().replace(/^-/, ''));
          }
          this.overlayList.push(item);
        }
      });
      //   this.overlayList.sort((a: ConcreteLayer, b: ConcreteLayer) => {
      //   return a.getTitle().localeCompare(b.getTitle());
      // });
      return this.overlayList;
    }));
  }

  public toggleOpenedGroups(groupName) {
    const index = this.openedGroups.indexOf(groupName);
    if (index < 0) {
      this.openedGroups.push(groupName);
    } else {
      this.openedGroups.splice(index, 1);
    }
  }

  public isOpenedGroup(groupName) {
    return this.openedGroups.includes(groupName);
  }


}
